// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"0ff240bf","478":"e7a2e1cf"}[chunkId] + ".chunk.js";
};